import React, { useState, useEffect, useMemo, useContext } from 'react';
import { TextStyle, LegacyStack} from '@shopify/polaris';
import { OfficeHourSubscriptionsContext } from '../../contexts/OfficeHourSubscriptions'
import { SubscriptionCodesContext } from '../../contexts/SubscriptionCodes'
import { ProductsContext } from '../../contexts/Products'
import { RecursContext } from '../../contexts/Recurs'
import { UserContext } from '../../contexts/User'
import { LineItemsExtensionContext } from '../../contexts/LineItemsExtension'
import Subscriptionable from '../../concerns/Subscriptionable'
import Productable from '../../concerns/Productable'
import Reassignable from '../../concerns/Reassignable'
import EditAssigned from './EditAssigned'
import RecurInfo from './RecurInfo'

export default function OfficeHourRow(props) {
  const officeHourSubscriptions = useContext(OfficeHourSubscriptionsContext)
  const lineItemsExtension = useContext(LineItemsExtensionContext)
  const subscriptionCodes = useContext(SubscriptionCodesContext)
  const [products] = useContext(ProductsContext)
  const [recurs] = useContext(RecursContext)
  const user = useContext(UserContext)

  const officeHourSubscription = officeHourSubscriptions.find((oh) => oh.id == props.id)
  if(!officeHourSubscription) {
    throw Error(`no officeHourSubscription found for id ${props.id} in : ${officeHourSubscriptions.map((oh) => oh.id)}`)
  }

  const [saving, setSaving] = useState(false);
  const imageSrc = Productable.imageSrc(products, officeHourSubscription)
  const assignedToText = Subscriptionable.assignedToText(officeHourSubscription)
  const startAtText = Subscriptionable.startAtText(officeHourSubscription, subscriptionCodes)
  const endAtText = Subscriptionable.endAtText(officeHourSubscription, lineItemsExtension)
  const reassignableFlags = Reassignable.flagsOfficeHour(officeHourSubscription, subscriptionCodes, user)
  const monthlySubscription = Subscriptionable.monthlySubscription(officeHourSubscription, lineItemsExtension)
  const recur = recurs.find((recur) => recur.matches(officeHourSubscription.orderId))
  const isStudent = officeHourSubscription.isStudent(user)

  return (<tr className={`office-hour-row ${saving ? 'subscription-row-saving' : ''} `}>
        <td className="thumbnail"><img src={imageSrc}/></td>
        <td>
          <span className="name">{officeHourSubscription.title}</span><br/>
          { officeHourSubscription.isEnrolled ?
          <span className="schedule">{officeHourSubscription.rsvpUrl ? <a className="rsvp-link" href={officeHourSubscription.rsvpUrl} target="_blank">Schedule a Session</a> : ''}</span>
          : null }
          { monthlySubscription ?
            <RecurInfo
              subscription={officeHourSubscription}
              recur={recur}
            /> : null
          }
        </td>
        <td className="start-at">{startAtText}</td>
        <td className="end-at">{endAtText}</td>
        <td className="assigned-to">{assignedToText}</td>
        <td colSpan="2"></td>
        { !officeHourSubscription.isEnrolled ?
          <td className="assign">
            <EditAssigned
              is_office_hour
              subscription={officeHourSubscription}
              onSaving={setSaving}
              unassignedLinkText="Assign" />
          </td> :
            !reassignableFlags.length ?
              <td className="reassign">
                <EditAssigned
                  is_office_hour
                  subscription={officeHourSubscription}
                  onSaving={setSaving}
                />
              </td> :
              <td className={`reassign ${reassignableFlags}`}></td>

        }
    </tr>)
}
